import { useAuth } from "../../../../../contexts/auth/Context";
import { decodeUserInfo } from "../../../../../utils/user";
import { useSidebarToggle } from "../../../../../contexts/sidebar/useSidebarToggle";
import { SidebarHeader } from "./header";
import { SidebarSection } from "./section";
import { DailySalesNotifications } from "./dailySalesNotifications";
import { RecentAccessNotifications } from "./recentAccessNotifications";
import { SidebarStatusCard } from "./statusCard";

interface SidebarProps {
  variant?: "desktop" | "drawer";
  onClose?: () => void;
}

export const Sidebar = ({ variant = "desktop", onClose }: SidebarProps) => {
  const { token } = useAuth();
  const userInfo = decodeUserInfo(token);
  const { isLeftCollapsed } = useSidebarToggle();

  const isDrawer = variant === "drawer";

  const content = (
    <>
      <SidebarHeader onClose={isDrawer ? onClose : undefined} />

      <div className="flex-1 overflow-y-auto custom-scrollbar">
        <div className="p-2.5 space-y-3">
          <SidebarSection title="Información del usuario" icon="actions">
            <div className="bg-global-overlay-secondary rounded-md p-2 border border-global-secondary">
              <p className="text-size-2xs text-global-tertiary mb-0.5">Email</p>
              <p className="text-size-xs font-medium text-global-primary truncate">
                {userInfo.email || "No disponible"}
              </p>
            </div>
          </SidebarSection>

          <DailySalesNotifications />

          <RecentAccessNotifications />

          <SidebarStatusCard />
        </div>
      </div>

      <div className="px-2.5 py-2 border-t border-global-secondary">
        <div className="flex items-center justify-center gap-1.5 text-size-2xs text-global-muted">
          <div className="w-1.5 h-1.5 bg-(--metric-sales) rounded-full" />
          <span>Sesión activa</span>
        </div>
      </div>
    </>
  );

  if (isDrawer) {
    return (
      <aside className="flex flex-col h-full bg-global-primary overflow-hidden">
        {content}
      </aside>
    );
  }

  return (
    <div
      className="hidden xl:block shrink-0 sticky top-[calc(var(--height-navbar)+var(--height-env-banner))] left-0 z-40 h-[calc(100vh-var(--height-navbar)-var(--height-env-banner))] self-start overflow-hidden transition-[width] duration-300 ease-in-out"
      style={{ width: isLeftCollapsed ? 0 : "var(--width-sidebar)" }}
    >
      <aside className="flex flex-col h-full bg-global-primary border-r border-global-secondary overflow-hidden sidebar-width">
        {content}
      </aside>
    </div>
  );
};
